import type { EditorState } from "./store";
import type { EmailDocument, Selection, TextBlockTarget } from "./types";

export type CanvasInteractionState = {
  document: EmailDocument;
  selection: Selection;
  selectedBlockIds: string[];
  primaryBlockId: string | null;
  anchorBlockId: string | null;
  selectedRowIds: string[];
  primaryRowId: string | null;
  anchorRowId: string | null;
  textEditingBlock: TextBlockTarget | null;
};

let cachedCanvasInteractionState: CanvasInteractionState | null = null;

export const selectCanvasInteractionState = (
  s: EditorState,
): CanvasInteractionState => {
  if (
    cachedCanvasInteractionState !== null &&
    cachedCanvasInteractionState.document === s.document &&
    cachedCanvasInteractionState.selection === s.selection &&
    cachedCanvasInteractionState.selectedBlockIds === s.selectedBlockIds &&
    cachedCanvasInteractionState.primaryBlockId === s.primaryBlockId &&
    cachedCanvasInteractionState.anchorBlockId === s.anchorBlockId &&
    cachedCanvasInteractionState.selectedRowIds === s.selectedRowIds &&
    cachedCanvasInteractionState.primaryRowId === s.primaryRowId &&
    cachedCanvasInteractionState.anchorRowId === s.anchorRowId &&
    cachedCanvasInteractionState.textEditingBlock === s.textEditingBlock
  ) {
    return cachedCanvasInteractionState;
  }

  cachedCanvasInteractionState = {
    document: s.document,
    selection: s.selection,
    selectedBlockIds: s.selectedBlockIds,
    primaryBlockId: s.primaryBlockId,
    anchorBlockId: s.anchorBlockId,
    selectedRowIds: s.selectedRowIds,
    primaryRowId: s.primaryRowId,
    anchorRowId: s.anchorRowId,
    textEditingBlock: s.textEditingBlock,
  };
  return cachedCanvasInteractionState;
};

export const selectDocument = (s: EditorState) => s.document;
export const selectDocumentSections = (s: EditorState) => s.document.sections;
export const selectSelection = (s: EditorState) => s.selection;
export const selectSelectedBlockIds = (s: EditorState) => s.selectedBlockIds;
export const selectPrimaryBlockId = (s: EditorState) => s.primaryBlockId;
export const selectAnchorBlockId = (s: EditorState) => s.anchorBlockId;
export const selectSelectedRowIds = (s: EditorState) => s.selectedRowIds;
export const selectPrimaryRowId = (s: EditorState) => s.primaryRowId;
export const selectAnchorRowId = (s: EditorState) => s.anchorRowId;
export const selectMode = (s: EditorState) => s.mode;
export const selectSaveStatus = (s: EditorState) => s.saveStatus;
export const selectPastCount = (s: EditorState) => s.past.length;
export const selectFutureCount = (s: EditorState) => s.future.length;
export const selectTextEditingBlock = (s: EditorState) => s.textEditingBlock;
export const selectTextEditReentryGuard = (s: EditorState) =>
  s.textEditReentryGuard;
export const selectEmailSettings = (s: EditorState) => s.document.settings;
export const selectTemplateId = (s: EditorState) => s.templateId;
